import { BaseModel } from '@/models/BaseModel';
import { BaseCollection } from './BaseCollection';
import type { MutationsObject } from '@kp/js-model';
import type { Dayjs } from 'dayjs';
import dayjs from 'dayjs';
import { createModel } from '@kp/js-model';

export class ReduktionWaermeerzeuger extends BaseModel {
    // properties
    id: number | null = null;
    created: Dayjs | null = null;
    modified: Dayjs | null = null;
    creator_id: number | null = null;
    modifier_id: number | null = null;

    bauperiode_id: number | null = null;
    waermeerzeuger_heizung_id: number | null = null;
    reduktion: number | null = null;
    bemerkung: string | null = null;

    // view fields
    bauperiode_i18n_key: string | null = null;
    bauperiode_code: number | null = null;
    waermeerzeuger_heizung: string | null = null;

    public mutations(): MutationsObject {
        return {
            created: (val) => dayjs(val),
            modified: (val) => dayjs(val),
        };
    }

    getClassName(): string {
        return 'ReduktionWaermeerzeuger';
    }
}

export async function createNewReduktionWaermeerzeuger(): Promise<ReduktionWaermeerzeuger> {
    const model = createModel(ReduktionWaermeerzeuger, {});

    await model.save();
    return model;
}

export class ReduktionWaermeerzeugerCollection extends BaseCollection<ReduktionWaermeerzeuger> {
    protected modelCls = ReduktionWaermeerzeuger;

    public getModelClassName(): string {
        return 'ReduktionWaermeerzeuger';
    }
}
